import { memo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { isNullable } from '../../../../../../../packages/utils/src';
import WidgetFrame from './WidgetFrame';

/**
 * Component that renders the widget which belongs to a column.
 */

const Widgets = ({
  columnIndex,
  columnsLength,
  columnOrientation = 'horizontal',
  editable,
  frameComponent,
  msg,
  onEdit,
  onMove,
  onRemove,
  onSortWidgets,
  rowIndex,
  widgets,
  widgetTypes,
}) => {
  const createdWidgets = widgets.map((widget, index) => {
    if (
      isNullable(widget) ||
      isNullable(widget.key) ||
      isNullable(widgetTypes[widget.key])
    ) {
      return null;
    }

    const Widget = widgetTypes[widget.key].type;
    return (
      <WidgetFrame
        columnIndex={columnIndex}
        columnsLength={columnsLength}
        columnOrientation={columnOrientation}
        disableEdit={widgetTypes[widget.key].disableEdit}
        editable={editable}
        frameComponent={frameComponent}
        // biome-ignore lint/suspicious/noArrayIndexKey: legacy code
        key={index}
        msg={msg}
        onEdit={onEdit}
        onMove={onMove}
        onRemove={onRemove}
        onSortWidgets={onSortWidgets}
        rowIndex={rowIndex}
        showTitle={widgetTypes[widget.key].showTitle}
        title={widgetTypes[widget.key].title}
        widgetIndex={index}
        widgetName={widget.key}
        widgetProps={widget.props}
      >
        <Widget
          {...widgetTypes[widget.key].props}
          {...widget.props}
          editable={editable}
          disableLink={editable}
        />
        {
          // createElement(widgetTypes[widget.key].type, widgetTypes[widget.key].props)
        }
      </WidgetFrame>
    );
  });
  return (
    <div
      className={classNames(
        'flow-root',
        'dazzle__column-content',
        columnOrientation === 'horizontal' ? 'flex' : 'block',
      )}
    >
      {createdWidgets}
    </div>
  );
};

Widgets.propTypes = {
  /**
   * Widgets that should be rendered.
   */
  widgets: PropTypes.array,

  /**
   * Widgets that are available in the dashboard.
   */
  widgetTypes: PropTypes.object,

  /**
   * Function that should be called when a widget is about to be removed.
   */
  onRemove: PropTypes.func,

  /**
   * Index of the column these widgets should be placed.
   */
  columnIndex: PropTypes.number,

  /**
   * Index of the row these widgets should be placed.
   */
  rowIndex: PropTypes.number,

  /**
   * Indicates weatehr dashboard is in ediable mode or not.
   */
  editable: PropTypes.bool,

  /**
   * User provided widget frame that should be used instead of the default one.
   */
  frameComponent: PropTypes.func,

  /**
   * Method to call when a widget is moved.
   */
  onMove: PropTypes.func,

  columnOrientation: PropTypes.string,
  onEdit: PropTypes.func.isRequired,
  onSortWidgets: PropTypes.func.isRequired,
  msg: PropTypes.object.isRequired,
  columnsLength: PropTypes.number.isRequired,
};

export default memo(Widgets);
